<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/GfmBdl/tc-custom/9781504099011.jpg?1734326750662" alt="This image is the cover for the book Year of the Tiger, The Paul Chavasse Novels"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Year of the Tiger, The Paul Chavasse Novels
      </h1>
      <p class="bookDescription body article font2">
        <p><b>A Cold War–era British spy infiltrates Chinese-occupied Tibet to rescue a scientist in this historical thriller by a <i>New York Times</i>–bestselling author.</b></p><p> 1962. The Cold War is on. The key to the West beating the Soviets to the moon is scientist Dr. Karl Hoffner, living under house arrest in Chinese-controlled Tibet. </p><p> In 1959, British Intelligence agent Paul Chavasse helped the Dalai Lama escape Tibet. Now his government has persuaded him to go back for Hoffner. Chavasse knows the language and the land. He also knows how important it is to get the scientist back alive. . .  </p><p> But trouble can be waiting for him anywhere. Perhaps on the illegal flight through the Himalayas or among the Chinese occupiers or the distrustful natives. Maybe with Tibetan freedom fighters or a trigger-happy army. Or at the hands of a beautiful woman . . . </p><p> When the fate of the world hangs in the balance, a spy can never be too careful. </p><p><b>Praise for <i>Year of the Tiger </i></b><b><i> </i></b></p><b>“Like his other novels, this one is loaded with action and adventure; it is Higgins at his best.” —<i>Booklist</i></b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jack Higgins
      </h2>
      
      <p class="authorDescription body article"><P> Jack Higgins is the <I>New York Times</I> bestselling author of more than sixty thrillers that have sold over 250 million copies worldwide, including <I>The Eagle Has Landed</I> and <I>The Wolf at the Door</I>. Before beginning his writing career, Higgins served in the British Army along the East German border. He lives in the Channel Islands. </P><P> &#160; </P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?94948f8e